import { type AilmentType, ailmentConfig } from "routes/calendar/helpers/getAilments";
import { MarketTypes } from "types";

export type ResourceCategory = "video" | "guidelines" | "payroll" | "evaluation";

export type Resource = {
  title: string;
  url: string;
  categories?: ResourceCategory[];
  ailments?: AilmentType[];
};

export const ailments = Object.keys(ailmentConfig) as AilmentType[];

const resourceListUS: Resource[] = [
  {
    title: "Joint Academy Evaluations",
    url: "https://drive.google.com/file/d/1OP-xN6ilLtE6SgVRDGZ-mxAij-hodUeQ/view?usp=drive_link",
    categories: ["guidelines", "evaluation"],
  },
  {
    title: "Create Your Own Treatment Programs",
    url: "https://drive.google.com/file/d/1uqJtTidcHsJK4VT9eMgCARcXX3_Wboyf/view?usp=drive_link",
    categories: ["guidelines"],
    ailments,
  },
  {
    title: "Scheduling a Patient With the Calendar Feature",
    url: "https://drive.google.com/file/d/1BuB5gH4qpTjG66W71YGfMeKH-OfWTeMZ/view?usp=drive_link",
    categories: ["guidelines", "evaluation"],
    ailments,
  },
  {
    title: "Training Video for All Joints",
    url: "https://drive.google.com/file/d/1AqFRjM4GNniM4hvZRlnc77BgQJ-c3cc5/view?usp=drive_link",
    categories: ["video"],
    ailments,
  },
  {
    title: "Guidelines for Treating Ankle/Foot Patients",
    url: "https://drive.google.com/file/d/1P2gcIoeftqqGXb11U9bjodKzNJbW7Bc3/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["foot"],
  },
  {
    title: "Guidelines for Treating Balance Patients",
    url: "https://drive.google.com/file/d/1bHs1LMKpZRGuz-LbyUCm8UJ1tCJeF2Ky/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["fall_prevention"],
  },
  {
    title: "Guidelines for Treating Elbow Patients",
    url: "https://drive.google.com/file/d/1bHHetYMEj32-Lytsyn906Eko7B2AZcv1/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["elbow"],
  },
  {
    title: "Guidelines for Treating Hand/Wrist Patients",
    url: "https://drive.google.com/file/d/1CStpdJASTD34XZQIRbXjqw0zM4mz5FJ7/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["hand", "wrist"],
  },
  {
    title: "Guidelines for Treating Hip Patients",
    url: "https://drive.google.com/file/d/1VRzUl4jX_DsdffI3072WaVN9BSzWHxr4/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["hip"],
  },
  {
    title: "Guidelines for Treating Knee Patients",
    url: "https://drive.google.com/file/d/15FAfIMP5gvPfv7iIiPZOSF0cuKhdV_Z0/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["knee"],
  },
  {
    title: "Guidelines for Treating Low Back Patients",
    url: "https://drive.google.com/file/d/1dsinQ0_WM001PambJzcjBEUqTfs_TyP2/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["lower_back"],
  },
  {
    title: "Guidelines for Treating Neck Patients",
    url: "https://drive.google.com/file/d/1cL0R_iZMqHbtKF5xddiy7Hkrlx51NXuz/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["neck"],
  },
  {
    title: "Guidelines for Treating Osteoporosis Patients",
    url: "https://drive.google.com/file/d/1F07GKstpgKepB11fzVidAHI7NyM8j2iH/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["osteoporosis"],
  },
  {
    title: "Guidelines for Treating Shoulder Patients",
    url: "https://drive.google.com/file/d/1inB1JTxgGakUcNU1hwKgt0p030ISuJeS/view?usp=drive_link",
    categories: ["guidelines"],
    ailments: ["shoulder"],
  },
  {
    title: "Monthly Payroll Invoice",
    url: "https://drive.google.com/file/d/1GQkVs4_f_dZNIk36k46oFZueKdsS4_qs/view?usp=drive_link",
    categories: ["payroll"],
  },
];

export const getResources = (market?: string): Resource[] => {
  switch (market) {
    case MarketTypes.US:
      return resourceListUS;
    default:
      return [];
  }
};
